import getConfig from 'next/config';
import React, { Component } from 'react';
import Router from 'next/router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import is from 'is_js';
// import { Button } from '@binance/uikit';
import { WindowScroller, Column, AutoSizer } from 'react-virtualized';
import { Flex, Button } from '@bijie/react-bnb';
// import Loading from '@/components/Loading'
import LoadingShade from '@/components/LoadingShade';

import memoizeOne from '../utils/memorizeOne';
// $FlowFixMe
import shallowEqual from '../utils/shallowEqual';
import withErrorHandler from '../utils/withErrorHandler';
import { formatNumber } from '../utils/number';
import withI18n from '../utils/withI18n';
import { getLabel } from '../utils/i18n';
import { setItem } from '../utils/localStorage';
import { OnRowClick } from '../utils/dataTypes';
import { isShowFiatPrice } from '../utils/isShowFiatPrice';
import SearchInput from './SearchInput';
import { TableWithoutScrollBars } from './ScrollableTable';
import SymbolsRowRenderer from './SymbolsList/SymbolsRowRenderer';
import FlexBox from './FlexBox';
import Icon from './Icon';
import { FiatPrice, getFiatPrice } from './FiatPrice';
import NoData from './NoData';
import { setInitFavorite as setInitFavoriteAction, getTopMovesList, fetchProductData } from '../actions/actionsSet/assetService';
import { setSelectedPair as setSelectedPairAction, setSelectedAssetTab as setSelectedAssetTabAction } from '../actions/settings';
import { isServer } from '../utils/isServer';

import featureConfig from '../config/feature';
import { track, sensorEventTypes } from '../utils/sensors';
import FavoriteStar from './SymbolsList/FavoriteStar';
import SortIndicator from './SymbolsList/SortIndicator';
import gtmTrack from '../utils/gtmTrack';

const {
  publicRuntimeConfig: { assetPrefix },
} = getConfig();

const { defaultSelectedStableCoinTabs } = featureConfig;
const STABLE_COIN_BASES = Object.keys(defaultSelectedStableCoinTabs);

const DEFAULT_ROW_HEIGHT = 54;
const HEADER_HEIGHT = 30;
const ROW_HEIGHT = 54;
const FAVORITE_STAR_STYLE = { padding: '8px 14px', marginRight: '10px' };
const ALIGN_RIGHT = { justifyContent: 'flex-end' };
const VOLUME_STYLE = { paddingRight: '15px', ...ALIGN_RIGHT };

const Wrap = styled.div`
  width: 100%;
  /* height: 805px; */
  margin-bottom: 30px;
`;

const SymbolsListBox = styled(FlexBox)`
  width: 100%;
  /* height: 805px; */
  left: 0;
  top: 0;
  transition: all 0.3s ease-in;
  background: #fff;
  box-shadow: inset 0px -1px 0px #e6e8ea;
  border-radius: 4px;
  padding: 0 20px 24px 20px;
  .fiat-price {
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
`;

const Amount = styled.span`
  padding-right: 1px;
`;

const GreenAmount = styled(Amount)`
  color: ${({ theme }) => theme.up};
`;

const GreenAmountPlus = styled(Amount)`
  color: ${({ theme }) => theme.up};
`;
const RedAmount = styled(Amount)`
  color: ${({ theme }) => theme.down};
`;

const SearchBox = styled(FlexBox)`
  padding: 0px;
  width: 270px;
  border-radius: 4px;
  border: 1px solid #e6e8ea;
  &:hover {
    border: 1px solid #f0b90b;
  }
  input {
    border: none;
    font-size: 30px;
    padding-left: 10px;
    padding-right: 0px;
    font-size: 16px;
    padding-bottom: 4px;
    background: transparent;
    ::-webkit-input-placeholder {
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: 16px;
      color: rgba(132, 142, 156, 0.5) !important;
      /* line-height: 32px; */
    }
    :-moz-placeholder {
      /* Firefox 18- */
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: 16px;
      color: rgba(132, 142, 156, 0.5) !important;
      /* line-height: 32px; */
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: 16px;
      color: rgba(132, 142, 156, 0.5) !important;
      /* line-height: 32px; */
    }
    :-ms-input-placeholder {
      font-family: ${({ theme }) => theme.fontIBMLight};
      font-size: 16px;
      color: rgba(132, 142, 156, 0.5) !important;
      /* line-height: 32px; */
    }
  }
  .iconfont {
    font-size: 16px;
    top: 50%;
    padding-left: 0px;
  }
  @media screen and (max-width: 1200px) {
    & {
      width: 168px;
    }
  }
  @media screen and (max-width: 992px) {
    & {
      display: none;
    }
  }
`;

const TabContainer = styled(FlexBox)`
  width: 100%;
  padding: 0 20px;
  border-bottom: 1px solid #f2f2f2;
  /* position: relative; */
  justify-content: space-between;
  position: sticky;
  top: 60px;
  background: #fff;
  z-index: 9;
  overflow-x: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const Tabs = styled(FlexBox)`
  position: relative;
  white-space: normal;
  flex-wrap: nowrap;
`;
// border-bottom-color: ${({ selected, theme }) => selected ? theme.bg : ''};
const Tab = styled.button`
  cursor: pointer;
  transition: none;
  user-select: none;
  background: none;
  outline: none;
  border: none;
  overflow: hidden;
  font-weight: ${({ selected }) => (selected ? '500' : '400')};
  font-size: 20px;
  padding: 24px 20px;
  position: relative;
  white-space: nowrap;
  :after {
    content: ' ';
    display: inline-block;
    height: 4px;
    background: ${({ theme }) => theme.highlight};
    position: absolute;
    bottom: -2px;
    left: 20px;
    right: 20px;
  }
  ${({ selected }) => (selected ? ':after {display: block};' : ':after {display: none};')} /* border: 1px solid ${({ isFixed }) => {
  if (isFixed) return 'transparent';
  return '#e6e6e6';
}}; */

  @media screen and (max-width: 576px) {
    & {
      padding: 18px 8px;
      font-size: 14px;
    }
    &:after {
      left: 8px;
      right: 8px;
    }
  }
`;

const TableBox = styled(FlexBox)`
  width: 100%;
  height: ${({ height }) => height}px;
  margin: auto;
  .ReactVirtualized__Table {
    width: 100%;
  }

  .ReactVirtualized__Table__headerRow {
    background: #fff;
    position: sticky;
    z-index: 1;
    top: 138px;
    border-bottom: 1px solid;
    border-color: #eaecef;
    text-transform: none;
    @media screen and (max-width: 576px) {
      top: 117px;
    }
    .ReactVirtualized__Table__sortableHeaderIcon {
      display: none;
    }
    .ReactVirtualized__Table__headerColumn,
    .ReactVirtualized__Table__rowColumn {
      margin-right: 0;
    }
    .ReactVirtualized__Table__headerColumn {
      @media screen and (max-width: 1200px) {
        &:nth-child(8) {
          display: none;
        }
      }
      @media screen and (max-width: 992px) {
        &:nth-child(6),
        &:nth-child(7) {
          display: none;
        }
      }
      @media screen and (max-width: 834px) {
        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8),
        &:nth-child(10) {
          display: none;
        }
      }
      @media screen and (max-width: 576px) {
        &:nth-child(3),
        &:nth-child(9) {
          display: none;
        }
      }
    }
  }
  .ReactVirtualized__Table__headerColumn {
    border-right: none !important;
    > * {
      margin-top: 16px;
    }
  }
  .ReactVirtualized__Table__headerTruncatedText {
    color: #1e2329;
    font-weight: 400;
    font-size: 10px;
  }
  .ReactVirtualized__Table__headerColumn:last-of-type,
  .ReactVirtualized__Table__rowColumn:last-of-type {
    margin-right: 8px;
  }
  .ReactVirtualized__Table__headerColumn:first-of-type,
  .ReactVirtualized__Table__rowColumn:first-of-type {
    margin-left: 8px;
  }
  .ReactVirtualized__Table__row {
    width: 100%;
    border-bottom: 1px solid #eaecef;
    &:hover {
      .ReactVirtualized__Table__rowColumn {
        @media screen and (max-width: 834px) {
          &:nth-child(9) {
            opacity: 0;
          }
        }
        @media screen and (max-width: 576px) {
          &:nth-child(5),
          &:nth-child(4) {
            opacity: 0;
          }
        }
      }
    }
    .ReactVirtualized__Table__rowColumn {
      font-size: ${({ fontSize }) => fontSize};
      color: #0b0e11;
      margin-right: 0;
      &:nth-child(1) {
        z-index: 3;
      }
      @media screen and (max-width: 1200px) {
        &:nth-child(8) {
          display: none;
        }
      }
      @media screen and (max-width: 992px) {
        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8) {
          display: none;
        }
      }
      @media screen and (max-width: 834px) {
        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8),
        &:nth-child(10) {
          display: none;
        }
      }
      @media screen and (max-width: 576px) {
        &:nth-child(3),
        &:nth-child(9) {
          display: none;
        }
      }
    }
  }
`;

const SymbolBox = styled.div`
  > strong {
    font-weight: 500;
    color: rgba(33, 40, 51, 1);
    line-height: 22px;
    font-weight: 500;
  }
  > span {
    font-weight: 500;
    color: rgba(132, 142, 156, 1);
    line-height: 18px;
  }
`;

const SelectMarketsBox = styled.span`
  display: inline-block;
  margin-left: 10px;
  height: 22px;
  width: 70px;
  padding: 0 22px 0 10px;
  border-radius: 11px;
  background: #fff;
  border: 1px solid #eaecef;
  font-size: 14px;
  font-weight: 500;
  color: rgba(132, 142, 156, 1);
  line-height: 20px;
  outline: none;
  cursor: pointer;
  position: relative;
  .iconfont {
    position: absolute;
    right: 10px;
    top: 0px;
    line-height: 22px;
    transform: scale(0.8);
  }
`;

const RowContainer = styled.div`
  text-align: right;

  position: relative;
  width: 100%;
  .btns-area {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    padding-right: 8px;
    align-items: center;
    justify-content: end;
  }
  .btns-area {
    visibility: hidden;
  }
`;

const mapStateToProps = ({
  tickers, locale, favorites, fiatRate, currencyList, userPreferredCurrency, isLoggedIn, favoritesFetched,
}) => ({
  tickers,
  locale,
  favorites,
  fiatRate,
  currencyList,
  userPreferredCurrency,
  isLoggedIn,
  favoritesFetched,
});
const mapDispatchToProps = {
  setInitFavorite: setInitFavoriteAction,
  setSelectedPair: setSelectedPairAction,
  setSelectedAssetTab: setSelectedAssetTabAction,
  getTopMovesList,
  fetchProductData,
};

export default
@withI18n
@withErrorHandler
@connect(mapStateToProps, mapDispatchToProps)
class SymbolsList extends Component {
  static propTypes = {
    tickers: PropTypes.object,
    i18n: PropTypes.object,
    locale: PropTypes.string,
    favorites: PropTypes.array,
    pro: PropTypes.bool,
    callbackToggleFn: PropTypes.func,
    setInitFavorite: PropTypes.func.isRequired,
    setSelectedPair: PropTypes.func,
    setSelectedAssetTab: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    favoritesFetched: PropTypes.bool,
  };

  static defaultProps = {
    tickers: [],
    i18n: {},
    locale: '',
    favorites: [],
    pro: false,
    favoritesFetched: false,
    callbackToggleFn: () => {},
    setSelectedPair: () => {},
    setSelectedAssetTab: () => {},
  };

  _tick = null;

  _priceColor = {};

  _lastPriceCollection = {};

  _divRef = React.createRef();

  constructor(props) {
    super(props);
    const { tickers } = this.props;
    Object.keys(tickers).map((item) => {
      this._priceColor[item] = 0;
      this._lastPriceCollection[item] = [1];
      return null;
    });

    this.state = {
      filterByAsset: 'BTC',
      filterKeyword: '',
      sortDirection: 'DESC',
      sortBy: 'q',
      showFavorites: false,
      loading: false,
      parentMarkets: [],
      selectedCoin: {
        'USDⓈ': 'ALL',
        'ALTS': 'ALL',
      },
      selectedTab: '',
      tick: null,
    };
    this._windowScroller = React.createRef();
  }

  componentDidMount() {
    /* eslint-disable */
    // fix issue when refresh while scrolled half way down the page
    setTimeout(() => {
      const { scrollTop } = document.documentElement;

      if (is.number(scrollTop) && scrollTop === 0) return;

      const { current } = this._windowScroller;

      if (!current) return;
      current.__handleWindowScrollEvent && current.__handleWindowScrollEvent();

      // reset isScrolling to false.
      current.__resetIsScrolling && current.__resetIsScrolling();
    }, 0);

    // ssr转csr，for test
    this.setState({
      loading: true,
    });
    // this.props.fetchProductData();
    // this.props.getTopMovesList();

    Promise.all([this.props.fetchProductData(), this.props.getTopMovesList()]).then(() => {
      this.setState({
        loading: false,
      });

      const { isLoggedIn } = this.props;
      const parentMarkets = this._getParentMarketNames();
      this.setState({
        parentMarkets,
      });
      if (isLoggedIn) {
        this.setState({
          selectedTab: 'favorites',
        });
      } else {
        this.setState({
          selectedTab: parentMarkets[0],
        });
      }
    });
    // setInterval(() => {
    //   this.props.getTopMovesList();
    // }, 60 * 1000); // 更新频率为60s

    this._tick = setInterval(() => this.setState({ tick: Date.now() }), 5000);

    // init favorites
    this.props.setInitFavorite();

    if (!isServer) {
      if (sessionStorage.getItem('filterByAsset')) {
        if (!isServer) this.setState({ filterByAsset: sessionStorage.getItem('filterByAsset') || '' });
      }
      if (sessionStorage.getItem('showFavorites')) {
        if (!isServer)
          this.setState({
            showFavorites: JSON.parse(sessionStorage.getItem('showFavorites') || 'false'),
          });
      }
    }

    this.DEFAULT_WIDTH = this._divRef?.current?.clientWidth || 1200;
  }

  shouldComponentUpdate(nextProps, nextState): boolean {
    return (
      !shallowEqual(nextState, this.state) || (is.empty(this.props.fiatRate) && !is.empty(nextProps.fiatRate)) || nextProps.isLoggedIn !== this.props.isLoggedIn
    );
  }

  componentDidUpdate() {
    const { tickers } = this.props;
    window.document.body.style.overflow = 'auto';

    // update price color
    const tickersArr = Object.entries(tickers);
    const priceColor = {};
    tickersArr.map((item: [string, Ticker | any]) => {
      const { s, c } = item[1];
      const prevPrice = this._lastPriceCollection[s];
      if (Number(c) > Number(prevPrice)) {
        priceColor[s] = 1;
      } else if (Number(c) === Number(prevPrice)) {
        priceColor[s] = 0;
      } else {
        priceColor[s] = -1;
      }
      this._lastPriceCollection[s] = c;
      return null;
    });
    this._priceColor = priceColor;
  }

  componentWillUnmount() {
    window.document.body.style.overflow = 'auto';
    if (this._tick) clearInterval(this._tick);
  }

  // e.g. BTC, ETH, BNB, USDT, ...
  _getParentMarketNames() {
    const { tickers = [] } = this.props;
    const arr = [];
    Object.values(tickers).map((v) => {
      const { pn } = v;
      if (!arr.includes(pn)) {
        pn && arr.push(pn);
      }
      return null;
    });
    return arr;
  }

  _getMarketCup = (cellData) => {
    const { cs, qa: quoteAsset, c: price } = cellData;
    const { fiatRate, currencyList, userPreferredCurrency: preferredCurrency, locale } = this.props;
    const lastPrice = getFiatPrice({ fiatRate, currencyList, preferredCurrency, locale, quoteAsset, price, prefix: '' });
    if (!lastPrice)
      return {
        value: 0,
        symbol,
      };
    const { fiatPrice, symbol } = lastPrice;
    const value = Number(fiatPrice) * Number(cs);
    return {
      value,
      symbol,
    };
  };

  _formatMarketCup = (value, symbol) => {
    if (value > 0 && value < 1000000) return `${symbol}${formatNumber(value, 2)}`;
    if (value > 1000000) return `${symbol}${formatNumber(value / 1000000, 2)}M`;
    return '-';
  };

  _getFavorites() {
    return this.props.favorites;
  }

  _handleForceUpdate = () => {
    this.setState({ tick: Date.now() });
  };

  _cellGetter = ({ rowData }) => rowData[1];

  _cellRendererFavorite = ({ rowData, cellData }) => {
    const { blogo } = cellData;
    const { favorites = [], isLoggedIn } = this.props;
    const symbol = rowData[0];
    const active = favorites.includes(symbol);
    return (
      <>
        <div style={{ width: 20, marginRight: 8 }}>
          {isLoggedIn && <FavoriteStar key={symbol} style={FAVORITE_STAR_STYLE} symbol={symbol} active={active} handleForceUpdate={this._handleForceUpdate} />}
        </div>
        <div style={{ width: 20, textAlign: 'center', marginRight: 8 }}>
          <img src={blogo} width="16" height="16" />
        </div>
      </>
    );
  };

  _cellRendererMarketCap = ({ cellData }) => {
    const { value, symbol } = this._getMarketCup(cellData);
    return this._formatMarketCup(value, symbol);
  };

  _cellRendererMarkets = ({ cellData }) => <img src={`${assetPrefix}/kline/${cellData.s}.svg`} alt={cellData.s} width="100" height="30" />;

  getMarketPair = ([newSymbol, ticker]) => {
    const baseAsset = ticker.ba;
    const quoteAsset = newSymbol.split(baseAsset)[1];
    return `${baseAsset}_${quoteAsset}`;
  };

  getTradePageLinkHref = ([newSymbol, ticker]) => {
    const newPair = this.getMarketPair([newSymbol, ticker]);
    return `/en/trade/pro/${newPair}`;
  };

  goTrade = (rowData) => {
    Router.push(this.getTradePageLinkHref(rowData));
  };

  renderButton = (rowData) => {
    const { enableOcbs, ba, qa } = rowData[1];
    const { isLoggedIn } = this.props;

    return (
      <>
        {enableOcbs && (
          <Button
            className="btn-primary"
            style={{ padding: '6px 12px', marginRight: 8 }}
            onClick={(e) => {
              e.stopPropagation();
              gtmTrack({ ecommerce: null });
              gtmTrack({
                event: 'productClick',
                eventCategory: 'mk_buy',
                eventAction: 'click',
                eventLabel: `us_market::list_click_${ba}/${qa}_market::${this.state.selectedTab}`,
                layout: 'markets',
                elementid: 'trade_tradepair',
                ecommerce: {
                  click: {
                    actionField: { list: 'mk_buy' },
                    products: [
                      {
                        name: `pair::${ba}/${qa}`,
                        id: `${ba}/${qa}`,
                        price: 0,
                        brand: 'markets',
                        category: `markets`,
                        variant: 'markets',
                        position: '',
                      },
                    ],
                  },
                },
              });
              Router.push(`/en/buy-sell-crypto/${ba}`);
            }}
          >
            <img style={{ marginRight: 8 }} src={assetPrefix + require('../static/images/common/icon-market-buy.svg')} />
            {'Buy'}
          </Button>
        )}

        <Button
          className="btn-outline"
          style={enableOcbs ? { marginRight: 0, padding: '6px 12px' } : { marginRight: 0, width: 160 }}
          onClick={(e) => {
            e.stopPropagation();
            gtmTrack({ ecommerce: null });
            gtmTrack({
              event: 'productClick',
              eventCategory: 'mk_tradecard',
              eventAction: 'click',
              eventLabel: `us_market::list_click_${ba}/${qa}_market::${this.state.selectedTab}`,
              layout: 'markets',
              elementid: 'trade_tradepair',
              ecommerce: {
                click: {
                  actionField: { list: 'mk_tradecard' },
                  products: [
                    {
                      name: `pair::${ba}/${qa}`,
                      id: `${ba}/${qa}`,
                      price: 0,
                      brand: 'markets',
                      category: 'markets',
                      variant: 'markets',
                      position: '',
                    },
                  ],
                },
              },
            });
            this.goTrade(rowData);
          }}
        >
          <img style={{ marginRight: 8 }} src={assetPrefix + require('../static/images/common/icon-market-trade.svg')} />

          {'Trade'}
        </Button>
      </>
    );
  };

  _cellRendererKline = ({ cellData, rowData }) => {
    const { kline, s } = cellData;
    return <img className="mainImg" src={kline} alt={s} width="160" height="42" />;
  };
  _rowRenderer = (props) => {
    const { rowData } = props;
    const HoverRender = (
      <Flex alignItem="center" className="btns-area">
        {this.renderButton(rowData)}
      </Flex>
    );

    return (
      <RowContainer className="operation-container">
        <SymbolsRowRenderer HoverRender={HoverRender} {...props} />
      </RowContainer>
    );
  };
  _cellRendererVolume = ({ cellData }) => {
    const { q } = cellData;
    return formatNumber(q, 2);
  };

  _cellRendererPair = ({ cellData }) => {
    const { ba, qa } = cellData;
    return (
      <SymbolBox>
        <strong>{ba}</strong>
        <span>/{qa}</span>
      </SymbolBox>
    );
  };

  _cellRendererFullName = ({ cellData }) => {
    const { bn } = cellData;
    return <span style={{ maxWidth: 95, textOverflow: 'ellipsis', overflow: 'hidden' }}>{bn}</span>;
  };

  _cellRendererPrice = (cellData, priceColor) => {
    const { fiatRate } = this.props;
    if (cellData) {
      const { c, qa, s, tickSize } = cellData;
      const tk = Math.abs(Math.log10(tickSize));
      const colorState = priceColor[s];
      const price = formatNumber(c, tk);
      if (colorState === 1) {
        return (
          <div style={{ textAlign: 'left', lineHeight: '18px' }}>
            <GreenAmount>{price}</GreenAmount>
            {isShowFiatPrice(qa) ? (
              <div style={{ lineHeight: '8px' }}>
                <FiatPrice price={c} quoteAsset={qa} precision={2} color="#848E9C" fiatRate={fiatRate} />
              </div>
            ) : null}
          </div>
        );
      } else if (colorState === 0) {
        return (
          <div style={{ textAlign: 'left', lineHeight: '18px' }}>
            <Amount>{price}</Amount>
            {isShowFiatPrice(qa) ? (
              <div style={{ lineHeight: '8px' }}>
                <FiatPrice price={c} quoteAsset={qa} precision={2} color="#848E9C" fiatRate={fiatRate} />
              </div>
            ) : null}
          </div>
        );
      }
      return (
        <div style={{ textAlign: 'left', lineHeight: '18px' }}>
          <RedAmount>{price}</RedAmount>
          {isShowFiatPrice(qa) ? (
            <div style={{ lineHeight: '8px' }}>
              <FiatPrice price={c} quoteAsset={qa} precision={2} color="#848E9C" fiatRate={fiatRate} />{' '}
            </div>
          ) : null}
        </div>
      );
    }
    return null;
  };

  _cellRendererChange = ({ cellData }) => {
    if (cellData) {
      if (!Number(cellData.o)) return <Amount>–</Amount>;
      const change = ((cellData.c - cellData.o) / cellData.o) * 100;

      if (change > 0) {
        return <GreenAmountPlus>{formatNumber(change, 2, '', true)}%</GreenAmountPlus>;
      }
      return <RedAmount>{formatNumber(change, 2)}%</RedAmount>;
    }
    return null;
  };

  _cellRendererLow = ({ cellData }) => {
    const { l, tickSize } = cellData;
    const tk = Math.abs(Math.log10(tickSize));
    return formatNumber(l, tk);
  };

  _cellRendererHigh = ({ cellData }) => {
    const { h, tickSize } = cellData;
    const tk = Math.abs(Math.log10(tickSize));
    return formatNumber(h, tk);
  };

  _searchByKeyword = (val) => {
    if (this.state.filterKeyword.length === 0 && val.length !== 0) {
      track(sensorEventTypes.HOMEPAGE_PAIR_SEARCH);
    }
    const filterKeywordLower = val && val.toLowerCase();
    const list = this._getSearchList(filterKeywordLower);
    const result = list.length > 0 ? 'yes' : 'no';
    gtmTrack({
      event: 'mk_search',
      eventCategory: 'mk_searchbar',
      eventAction: 'click',
      eventLabel: `us_market::search_coin_${val}_${this.state.selectedTab}_${result}`,
      elementid: 'markets_main_search',
    });
    this.setState({
      filterKeyword: val,
    });
  };

  _getSearchList = (filterKeywordLower) => {
    const { tickers, pro } = this.props;
    const { selectedTab, selectedCoin } = this.state;
    const entries = Object.entries(tickers);
    const filteredList = () => {
      if (selectedTab === 'favorites') {
        return entries.filter(([s]) => this._getFavorites().includes(s));
      } else if (STABLE_COIN_BASES.includes(selectedTab) && selectedCoin[selectedTab] !== 'ALL') {
        return entries.filter((ticker) => ticker[1].pn === selectedTab && ticker[1].qa && ticker[1].qa === selectedCoin[selectedTab]);
      } else {
        return entries.filter((ticker) => ticker[1].pn === selectedTab);
      }
    };
    const memorizeFilteredList = memoizeOne(filteredList);
    const _filteredList = memorizeFilteredList(selectedTab);
    const searchedList = () =>
      _filteredList.filter(
        ([, { bn, ba }]) =>
          (ba && ba?.toLowerCase().includes(filterKeywordLower)) || (!is.undefined(bn) && !pro && bn?.toLowerCase().includes(filterKeywordLower))
      );
    const memorizeSearchedList = memoizeOne(searchedList);
    const _searchedList = memorizeSearchedList(filterKeywordLower);
    return _searchedList;
  };

  _sort = ({ sortBy, sortDirection }) => {
    gtmTrack({
      event: 'mk_filters',
      eventCategory: 'mk_filters',
      eventAction: 'click',
      eventLabel: `mk_filters::${this.state.selectedTab}_${sortBy}_${sortDirection}`,
      elementid: 'web_market_filter_click',
    });
    if (sortBy === '') return;
    this.setState({ sortBy, sortDirection });
  };

  _sortList = (sortBy, sortDirection, sortResource) =>
    sortResource.sort((a, b) => {
      const aCh = (a[1].c - a[1].o) / a[1].o;
      const bCh = (b[1].c - b[1].o) / b[1].o;
      const aMarketCup = this._getMarketCup(a[1]);
      const bMarketCup = this._getMarketCup(b[1]);
      if (sortDirection === 'DESC') {
        if (sortBy === 'ch') {
          if (Number.isNaN(aCh) || Number.isNaN(bCh)) {
            return Number.isNaN(aCh) ? 1 : -1;
          } else if (!Number.isFinite(aCh) && !Number.isFinite(bCh)) {
            return a[0] > b[0] ? 1 : -1;
          } else if (!Number.isFinite(aCh)) {
            return 1;
          }
          return bCh - aCh;
        } else if (sortBy === 's' || sortBy === 'bn') {
          return b[1][sortBy].localeCompare(a[1][sortBy]);
        } else if (sortBy === 'cs') {
          return bMarketCup.value - aMarketCup.value;
        }
        return b[1][sortBy] - a[1][sortBy];
      }

      if (sortBy === 'ch') {
        if (Number.isNaN(aCh) || Number.isNaN(bCh)) {
          return Number.isNaN(aCh) ? 1 : -1;
        } else if (!Number.isFinite(aCh) && !Number.isFinite(bCh)) {
          return a[0] < b[0] ? 1 : -1;
        } else if (!Number.isFinite(aCh)) {
          return 1;
        }
        return aCh - bCh;
      } else if (sortBy === 's' || sortBy === 'bn') {
        return a[1][sortBy].localeCompare(b[1][sortBy]);
      } else if (sortBy === 'cs') {
        return aMarketCup.value - bMarketCup.value;
      }
      return a[1][sortBy] - b[1][sortBy];
    });

  _onRowClick = ({ index }: OnRowClick) => {
    if (this.props.pro) this.props.callbackToggleFn();
    const pairLabel = 'bn.selectedPair';
    setItem(window.localStorage, pairLabel, `${this._sortedList[index][1].ba}_${this._sortedList[index][1].qa}`);
    this.props.setSelectedPair(`${this._sortedList[index][1].ba}_${this._sortedList[index][1].qa}`);
  };

  _handleFavoriteTab = () => {
    gtmTrack({
      event: 'trade_market_sector',
      eventCategory: 'mk_marketsector',
      eventAction: 'click',
      eventLabel: `us_market::sector_favorites`,
      elementid: 'markets_header',
    });
    this.setState({ showFavorites: true, selectedTab: 'favorites' });
  };

  _handleAssetTab = (val) => {
    gtmTrack({
      event: 'trade_market_sector',
      eventCategory: 'mk_marketsector',
      eventAction: 'click',
      eventLabel: `us_market::sector_${val}`,
      elementid: 'markets_header',
    });
    this.setState({
      filterByAsset: val,
      showFavorites: false,
      selectedTab: val,
    });
  };

  _getTableBoxHeight = (sortedList: Array<Object>, rowHeight: number) => {
    const { length } = sortedList;
    return length * rowHeight;
  };

  _getParentMarketNamesAndStableCoins = () => {
    const { tickers } = this.props;
    const stableCoins = {};
    STABLE_COIN_BASES.forEach((el) => {
      stableCoins[el] = ['ALL'];
    });
    const list = Object.values(tickers);
    list.forEach(({ pn, qa }) => {
      STABLE_COIN_BASES.forEach((el: string) => {
        if (el === pn && STABLE_COIN_BASES.includes(pn) && !stableCoins[el].includes(qa)) {
          stableCoins[el].push(qa);
        }
      });
    });
    return stableCoins;
  };

  _headerRenderer({ dataKey, sortBy, sortDirection }, label) {
    return (
      <>
        <span className="ReactVirtualized__Table__headerTruncatedText">{label}</span>
        {sortBy === dataKey && <SortIndicator sortDirection={sortDirection} />}
      </>
    );
  }
  render() {
    const { selectedTab, parentMarkets } = this.state;
    const { i18n, tickers, pro, isLoggedIn, favoritesFetched } = this.props;
    const { filterByAsset, filterKeyword, sortBy, sortDirection, showFavorites, selectedCoin, loading } = this.state;
    const filterKeywordLower = filterKeyword && filterKeyword.toLowerCase();
    const _searchedList = this._getSearchList(filterKeywordLower);
    const memorizedSort = memoizeOne(this._sortList);
    const sortedList = (this._sortedList = memorizedSort(sortBy, sortDirection, _searchedList));
    const tableWidth = this.DEFAULT_WIDTH;
    const rowHeight = DEFAULT_ROW_HEIGHT;
    const noDataSvg =
      filterKeyword && _searchedList.length === 0
        ? assetPrefix + require('../static/images/common/icon-no-search.svg')
        : assetPrefix + require('../static/images/common/icon-markets-no-data.svg');

    return (
      <Wrap>
        {/* {loading && <Loading fullScreen={true} inner={true} />} */}
        <LoadingShade hidden={!loading} />

        <TabContainer id="tabContainer" align="center">
          <Tabs>
            {isLoggedIn && (
              <Tab selected={selectedTab === 'favorites'} id="home-button-favorites" onClick={this._handleFavoriteTab}>
                {getLabel('exchange-home-Favorites', i18n)}
              </Tab>
            )}
            {parentMarkets.map((v, i) => (
              <Tab
                id={`IndexSymbolsList-button-${v}Markets`}
                key={i}
                selected={selectedTab === v}
                isStableCoinMarket={STABLE_COIN_BASES.includes(v)}
                onClick={() => this._handleAssetTab(v)}
              >
                {getLabel('exchange-home-Markets', i18n).replace('##', v)}
              </Tab>
            ))}
          </Tabs>
          <SearchBox justify="center" align="center">
            <SearchInput
              id="viewMoreMarkets-input-SearchCoinName"
              value={filterKeyword}
              placeholder={'Search'}
              onChange={this._searchByKeyword}
              height="40px"
              width="270px"
            />
          </SearchBox>
        </TabContainer>
        <SymbolsListBox ref={this._divRef} flex="1" direction="column" wrap="nowrap">
          {sortedList.length === 0 && !isServer && favoritesFetched ? (
            <NoData
              height={400}
              img={noDataSvg}
              msg={selectedTab === 'favorites' ? 'You don’t have any favorites yet' : 'Sorry, we couldn’t find what you’re looking for.'}
            />
          ) : (
            <TableBox flex={'1 0 auto'} height={sortedList.length * ROW_HEIGHT + HEADER_HEIGHT + 20} fontSize={'14px'}>
              <AutoSizer style={{ width: '100%' }}>
                {({ width, height, isScrolling, onChildScroll, scrollTop }) => (
                  <TableWithoutScrollBars
                    autoHeight={true}
                    height={height}
                    isScrolling={isScrolling}
                    overscanRowCount={20}
                    onScroll={onChildScroll}
                    scrollTop={scrollTop}
                    //width={this.DEFAULT_WIDTH}
                    width={width}
                    defaultHeight={sortedList.length}
                    headerHeight={rowHeight}
                    rowHeight={rowHeight}
                    rowCount={sortedList.length}
                    rowGetter={({ index }) => sortedList[index]}
                    rowRenderer={this._rowRenderer}
                    sort={this._sort}
                    sortBy={sortBy}
                    sortDirection={sortDirection}
                    // onRowClick={(e)=>{
                    //  this.goTrade(e.rowData)
                    // }}
                    showFavorites={selectedTab === 'favorites'}
                    filterKeyword={filterKeywordLower}
                    isHeaderBgWhite={true}
                    {...this.props}
                  >
                    <Column
                      label=""
                      dataKey="s"
                      disableSort={true}
                      width={isLoggedIn ? 56 : 36}
                      cellRenderer={this._cellRendererFavorite}
                      cellDataGetter={this._cellGetter}
                      style={ALIGN_RIGHT}
                    />
                    <Column
                      label={getLabel('exchange-home-Pair', i18n)}
                      dataKey="s"
                      width={tableWidth * 0.08}
                      flexGrow={1}
                      //flexShrink={0}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererPair}
                      headerRenderer={(...args) => this._headerRenderer(...args, 'Pair')}
                    />

                    <Column
                      dataKey="bn"
                      width={tableWidth * 0.08}
                      flexGrow={1.1}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererFullName}
                      headerRenderer={(...args) => this._headerRenderer(...args, 'Coin')}
                    />
                    <Column
                      dataKey="c"
                      flexGrow={1}
                      width={tableWidth * 0.08}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={(cellData) => this._cellRendererPrice(cellData.cellData, this._priceColor)}
                      headerRenderer={(...args) => this._headerRenderer(...args, 'Price')}
                    />
                    <Column
                      dataKey="ch"
                      width={80}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererChange}
                      headerStyle={ALIGN_RIGHT}
                      style={{ ...ALIGN_RIGHT }}
                      headerRenderer={(...args) => this._headerRenderer(...args, '24h Change')}
                    />
                    <Column
                      dataKey="h"
                      width={tableWidth * 0.12}
                      headerStyle={ALIGN_RIGHT}
                      style={ALIGN_RIGHT}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererHigh}
                      headerRenderer={(...args) => this._headerRenderer(...args, '24h high')}
                    />
                    <Column
                      dataKey="l"
                      width={tableWidth * 0.12}
                      headerStyle={ALIGN_RIGHT}
                      style={ALIGN_RIGHT}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererLow}
                      headerRenderer={(...args) => this._headerRenderer(...args, '24h low')}
                    />

                    <Column
                      dataKey="cs"
                      width={tableWidth * 0.1}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererMarketCap}
                      headerStyle={ALIGN_RIGHT}
                      style={ALIGN_RIGHT}
                      headerRenderer={(...args) => this._headerRenderer(...args, 'Market Cap')}
                    />

                    <Column
                      // label={getLabel('exchange-home-24h-volume', i18n)}
                      dataKey="q"
                      width={tableWidth * 0.12}
                      flexGrow={1}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererVolume}
                      headerStyle={VOLUME_STYLE}
                      style={VOLUME_STYLE}
                      headerRenderer={(...args) => this._headerRenderer(...args, '24h volume')}
                    />

                    <Column
                      label="24h Chart"
                      dataKey="cs"
                      width={160}
                      disableSort={true}
                      cellDataGetter={this._cellGetter}
                      cellRenderer={this._cellRendererKline}
                      headerStyle={ALIGN_RIGHT}
                      style={{ marginRight: 8 }}
                    />
                  </TableWithoutScrollBars>
                )}
              </AutoSizer>
            </TableBox>
          )}
        </SymbolsListBox>
      </Wrap>
    );
  }
}
